// extracted by mini-css-extract-plugin
export default {"wrapper":"pageLoader_wrapper__Q1YEI","spinner":"pageLoader_spinner__cgjw4","spin":"pageLoader_spin__tf6FW","srOnly":"pageLoader_srOnly__F8ljL"};